import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomersIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 20,
	viewBox: "0 0 23 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.11069 6.66669C7.95165 6.66669 9.44404 5.1743 9.44404 3.33335C9.44404 1.49239 7.95165 0 6.11069 0C4.26973 0 2.77734 1.49239 2.77734 3.33335C2.77734 5.1743 4.26973 6.66669 6.11069 6.66669Z",
			fill: "#85A0AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3247 19.1716L22.518 10.8382C22.7036 10.1338 22.1725 9.44434 21.443 9.44434H13.8597C13.3547 9.44434 12.9141 9.78434 12.7847 10.2727L10.5919 18.606C10.4063 19.3105 10.938 19.9999 11.6669 19.9999H19.2502C19.7552 19.9999 20.1964 19.6599 20.3247 19.1716Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.65948 17.222H3.61112C3.15112 17.222 2.77779 16.8486 2.77779 16.3886C2.77779 15.9286 3.15112 15.5553 3.61112 15.5553H9.09837L10.5061 10.2042C9.31726 8.97195 7.61892 8.23472 5.7478 8.34361C2.4839 8.53306 0 11.3736 0 14.6431V17.222C0 18.7564 1.24334 19.9998 2.77779 19.9998H7.92836L8.65948 17.222Z",
			fill: "#85A0AD"
		})
	]
});
export default SvgCustomersIcon;
